<template>
    <v-list
        dense
        nav
    >
        <v-list-item-group
            v-model="selectedItem"
            color="secondary"
        >
            <template
                v-for="(item, i) in menuPermissions"

            >
                <v-list-item
                    :key="i"
                    v-if="item.visible"
                    :disabled="item.disabled"
                    @click="display(item)"
                >
                    <v-list-item-icon v-if="item.visible">
                        <v-icon >{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content v-if="item.visible">
                        <v-list-item-title >
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </template>

        </v-list-item-group>
    </v-list>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'AdminNavigation',

    created: function () {
        this.initialize();
    },

    computed: {
        ...mapGetters({
            menuOptions: 'admin/getMenuOptions',
            userAdmin: 'admin/getUserAdmin',
            adminPermissions: 'auth/getAdminPermissions',
        })
    },

    data: () => ({

        items: [
            { text: 'Current Term', icon: 'mdi-view-dashboard', submenu: false, menu: 'dashboard', visible: true, disabled: false },
            { text: 'Teachers', icon: 'mdi-account-group', submenu: false, menu: 'employees', visible: true, disabled: false },
            { text: 'Students', icon: 'mdi-account-group', submenu: false, menu: 'students', visible: true, disabled: false, pta: true },
            { text: 'Subjects', icon: 'mdi-library', submenu: false, menu: 'studentSubjects', visible: true, disabled: false },
            { text: 'Post Term Reports', icon: 'mdi-post', submenu: false, menu: 'postReports', visible: true, disabled: false },
            { text: 'Edit\\View Term Details', icon: 'mdi-file-document-edit-outline', submenu: false, menu: 'termReports', visible: true, disabled: false },
            { text: 'Enter Marks', icon: 'mdi-keyboard', submenu: false, menu: 'enterMarks', visible: true, disabled: false },
            { text: 'Course Mark', icon: 'mdi-notebook', submenu: true, menu: 'courseMark', visible: true, disabled: false},
            { text: 'Reports', icon: 'mdi-file-cabinet', submenu: true, menu: 'reports', visible: true, disabled: false},
            { text: 'Registration', icon: 'mdi-calendar-clock', submenu: false, menu: 'registration', visible: true},
            { text: 'Promotion', icon: 'mdi-arrow-up-box', submenu: false, menu: 'promotion', visible: true},
            { text: 'Student Attendance', icon: 'mdi-bell', submenu: false, menu: 'attendanceStudent', visible: true, disabled: true },
            //{ text: 'Export Data', icon: 'mdi-database-export-outline', submenu: false, menu: 'exportData', visible: true },
            //{ text: 'Import Students', icon: 'mdi-cloud-upload-outline', submenu: false, menu: 'importData',visible: false },
        ],
        selectedItem: 0,
        menuPermissions: [],
    }),

    methods: {
        ...mapActions({
            registrationData: 'admin/downloadRegistrationData',
            getFormClasses: 'termReports/getFormClasses',
            getCodedCommentsList: 'termReports/getCodedCommentsList',
            currentPeriod: 'termReports/getCurrentAcademicPeriod',
        }),

        ...mapMutations({
            setMenuOptions: 'admin/setMenuOptions',
            editViewTermReportsOverlay: 'termReports/setEditViewTermReportsOverlay',
            editViewTermReportsLoading: 'termReports/setEditViewTermReportsLoading',
            setFormClassesList: 'termReports/setFormClassesList',
            setEditTermReports: 'admin/setEditTermReports',
            setProgressOverlay: 'admin/setProgressOverlay',
        }),

        async initialize () {
            this.setProgressOverlay(true);
            let menuOptions = {};
            const permissions = JSON.parse(this.adminPermissions);

            try {
                await this.currentPeriod();
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }

            this.items.forEach( value => {
                menuOptions[value.menu] = false;

                permissions.forEach(permission => {
                    if(permission.menu == value.menu){
                        this.menuPermissions.push(value)
                    }

                    if(permission.action == 'editTermReports') {
                        this.setEditTermReports(true);
                    }
                })

                // if(value.menu == 'dashboard'){
                //     menuOptions[value.menu] = true;
                // }

            })
            this.setMenuOptions(menuOptions);
            this.setProgressOverlay(false);

            if(this.menuPermissions.length == 0){
                return;
            }

            // this.$nextTick(() => {
            //     menuOptions[this.menuPermissions[0].menu] = true;
            // })

            setTimeout(() => {
                menuOptions[this.menuPermissions[0].menu] = true;
            }, 400)
            

        },


        display(item){
            console.log('menu item clicked');

            if(item.menu === 'promotion')
            {
                this.menuOptions[item.menu] = true;
                return;
            }

            if(this.menuOptions[item.menu]){
                // menu is open
                return;
            }

            Object.keys(this.menuOptions).forEach(key => {
                this.menuOptions[key] = false;
            })

            this.$nextTick(() => {
                this.menuOptions[item.menu] = true;
            })
            // if(key == item.menu){
            //     this.menuOptions[key] = true
            // }
        },


        downloadExcel () {
            this.registrationData()
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download','Registration Data.xlsx')
                document.body.appendChild(link)
                link.click()
                this.setExportData(false);
            })
        },
    }
}
</script>

<style scoped>
    ::v-deep .v-list-item__title{
        white-space: pre-line;
    }

    ::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
        color: #fff !important
    }

    ::v-deep .theme--light.v-icon{
        color: #bbb9b9;
    }

    ::v-deep .theme--light.v-list-item--disabled{
        color: #616161 !important;
    }

    /* ::v-deep .theme--light.v-icon{
        color: #fff
    } */

</style>